import React, { Fragment } from "react";
import { isEmpty, map } from "lodash";
import {
  HiddenBaseFields, HiddenQuestionAnswers, StepField,
  HiddenFieldsConditions, HiddenGridItemFields, HiddenAnswersSubgroupsFields, HiddenPinnedAnswersFields
} from "../../../common/custom_questions/components/HiddenFields";


const ImagesHiddenFields = ({ question, images }) => {
  if (isEmpty(images) && images != null) {
    return (
      <input type="hidden" name={ `project[custom_metrics][][answer_images]` } value="" />
    );
  }

  return (
    <>
      {
        map(images, (image_data, key) => (
          <input
            key={ `image${key}` }
            type="hidden"
            name={ `project[custom_metrics][][answer_images][${key}]` }
            value={ !question.as_point_scale ? image_data?.meta_data : '' }
          />
        ))
      }
    </>
  );
};

const HiddenFields = ({ questions, options, updated, conceptsCountEnabled, conceptsCountValue, type = "custom_metrics" }) => {
  return (
    <>
      <input type="hidden" name="custom_metrics_updated" id="custom_metrics_updated" value={ updated } />
      {
        conceptsCountEnabled &&
        <input
          type="hidden"
          name="project[concepts_count_for_custom_metrics]"
          id="concepts_count_for_custom_metrics"
          value={ conceptsCountValue }
        />
      }
      <StepField options={ options } />
      {
        map(questions, (question, index) => {
          return (
            <Fragment key={ `question${question.id}${index}` }>
              <HiddenBaseFields question={ question } metricType={ type } />
              <input type="hidden" name={ `project[${type}][][as_point_scale]` } value={ question.as_point_scale || false } />
              <input type="hidden" name={ `project[${type}][][prefix]` } value={ question.prefix || '' } />
              <input type="hidden" name={ `project[${type}][][use_custom_subgroups]` } value={ `${question.use_custom_subgroups}` || '' } />
              <HiddenQuestionAnswers question={ question } metricType={ type } />
              <HiddenFieldsConditions question={ question } metricType={ type } />
              {question.kind === "Grid" && <HiddenGridItemFields question={ question } metricType={ type } />}
              <HiddenAnswersSubgroupsFields question={ question } metricType={ type } />
              <HiddenPinnedAnswersFields question={ question } metricType={ type } />
              {!question.as_point_scale && <ImagesHiddenFields question={ question } images={ question.answer_images } />}
            </Fragment>
          );
        })
      }
    </>
  );
};

export default HiddenFields;
